module.exports = __webpack_public_path__ + "img/10885_L.0dd4cfbf.png";